import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { forYou, notForYou } from '../../data/content';
export function FitSection() {
  return <Section id="para-quien" tone="surface" data-id="element-131" data-mp="2uzgclmh92tgj">
      <div className="grid gap-6 lg:grid-cols-12" data-id="element-132" data-mp="2uyou9dcnys87">
        <div className="rounded-lg border border-line bg-ink p-7 sm:p-10 lg:col-span-7" data-id="element-133" data-mp="2z0jv6gqon3lg">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] text-white sm:text-5xl" data-id="element-134" data-mp="2l10ntq5p3wa7">
            Este diagnóstico es <span className="text-brand" data-id="element-135" data-mp="2q154phaimt0y">para ti</span> si…
          </h2>
          <ul className="mt-8 space-y-4" data-id="element-136" data-mp="2c0m0kl968742">
            {forYou.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-137" data-mp="2c2ozxvw7rclg">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand" data-id="element-138" data-mp="2g2fvecwoqgwb">
                  <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="a6v25rs68v2k" />
                </span>
                <span className="text-lg leading-snug text-white" data-id="element-140" data-mp="j0q25bu9iild">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="flex flex-col rounded-lg border border-line p-7 sm:p-10 lg:col-span-5" data-id="element-141" data-mp="e0lmtp53btwq">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] text-white sm:text-5xl" data-id="element-142" data-mp="sphrdc7xuosl">
            Esto <span className="text-muted" data-id="element-143" data-mp="nrydwej2eg1p">no</span> es para ti si…
          </h2>
          <ul className="mt-8 space-y-4" data-id="element-144" data-mp="2wzmanjwaoi">
            {notForYou.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-145" data-mp="3r8oq5b58ppbu">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-line" data-id="element-146" data-mp="3raj9wm4rzbec">
                  <XIcon className="h-3.5 w-3.5 text-muted" strokeWidth={3} aria-hidden="true" data-id="element-147" data-mp="50fc2b0s1819" />
                </span>
                <span className="text-lg leading-snug text-muted" data-id="element-148" data-mp="1le5gxjzq00by">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}